export default __webpack_public_path__ + "static/media/downloadIcon.81cdabc7.svg";